import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCardActivityScreenContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "CardActivityScreenContainer" */
                '@perpay-web/fintech/components/containers/CardActivityScreenContainer'
            ),
    );
